import { Union } from 'ts-toolbelt';

export const userNameLabel = ({
  firstName,
  lastName,
  email,
}: {
  firstName?: Union.Nullable<string>;
  lastName?: Union.Nullable<string>;
  email?: Union.Nullable<string>;
} = {}) => {
  const output = [
    //
    firstName || null,
    lastName || null,
    email ? `(${email})` : null,
  ].filter(Boolean);

  return output.join(' ');
};
